"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseModalContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const surface_1 = require("../surface");
const LINE_BREAK = '<br>';
const parseModalContent = (content) => {
    if (content.search(LINE_BREAK) === -1)
        return jsx_runtime_1.jsx(surface_1.Prose, { text: content }, void 0);
    const contentListWithBreak = content.split(LINE_BREAK);
    return contentListWithBreak.map((text, index) => (jsx_runtime_1.jsx(surface_1.Prose, { text: text, breakAfter: true }, index)));
};
exports.parseModalContent = parseModalContent;
//# sourceMappingURL=modals.js.map